import assets from "app/assets";
import localeManager from "app/assets/localeManager";
import config from "config";
import gsap from "gsap";
import Scroll from "lib/scroll";
import { Container, Graphics, NineSlicePlane, Sprite, TextStyle, Text, DEG_TO_RAD } from "pixi.js";
import tools from "tools";
import ScrollBtn from "./scrollBtn";
import SkinItem from "./skinItem";
const WIDTH = config.view.x - 10;
const HEIGHT = config.view.y - 10;
const PACK_CONTAINER_POS = -330;
export default class Skin extends Container {
  constructor() {
    super();
    tools.autobind(this);
    const background = new Graphics();
    background.beginFill(0x2c3856);
    background.drawRect(-.5, -.5, 1, 1);
    background.endFill();
    background.scale.set(WIDTH, HEIGHT);
    this.addChild(background);
    this._currentItem = null;
    this._init();
    this._initEvents();
  }
  _init() {
    this.close = new Sprite(assets.textures.popupBoosterClose.texture);
    this.close.anchor.set(.5);
    this.close.scale.set(.5);
    this.close.position.set(WIDTH / 2 - 38, -HEIGHT / 2 + 40);
    this.addChild(this.close);
    this.title = new NineSlicePlane(assets.textures.shopTitle.texture, 30, 30, 30, 30);
    this.title.width = WIDTH - 50;
    this.title.height = 80;
    this.title.x = -this.title.width / 2;
    this.title.y = -450;
    this.addChild(this.title);
    const textStyle = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: 35,
      align: "left",
      fill: 0xffffff,
      stroke: '#222222',
      strokeThickness: 5
    });
    this.titleText = new Text(assets.local.skinsTitle, textStyle);
    this.titleText.anchor.x = .5;
    this.titleText.anchor.y = .6;
    this.titleText.x = this.title.width / 2;
    this.titleText.y = this.title.height / 2;
    this.title.addChild(this.titleText);
    this.packContainer = new Container();
    this.packContainer.x = WIDTH / 2;
    this.scroll = new Scroll();
    this.scroll.axe = "y";
    this.scroll.viewY = 760;
    this.scroll.viewX = WIDTH;
    this.scroll.y = PACK_CONTAINER_POS;
    this.scroll.x = -WIDTH / 2;
    this.scroll.add(this.packContainer);
    this.scroll.visible = false;
    this.addChild(this.scroll);
    this.setBtns();
    this.visible = false;
    this.scale.set(.1);
  }
  _initEvents() {
    this.interactive = true;
    this.close.interactive = true;
    this.close.buttonMode = true;
    this.close.on('pointerdown', this._onDown);
    this.close.on('pointerup', this._onUp);
    this.close.on('pointerupoutside', this._onOut);
  }
  _onDown() {
    if (this._isDown) {
      return;
    }
    this._isDown = true;
    this.tween = gsap.to(this.close.scale, {
      duration: .2,
      x: .43,
      y: .43
    });
  }
  _onUp() {
    if (!this._isDown) {
      return;
    }
    this._isDown = false;
    this.tween && this.tween.kill();
    this.tween = gsap.to(this.close.scale, {
      duration: .2,
      x: .5,
      y: .5
    });
    this.hide();
  }
  _onOut() {
    this._isDown = false;
    this.tween && this.tween.kill();
    this.tween = gsap.to(this.close.scale, {
      duration: .2,
      x: .5,
      y: .5
    });
  }
  _invite() {}
  get size() {
    return {
      width: WIDTH,
      height: HEIGHT
    };
  }
  show(callback) {
    config.currentPopin = this;
    this.callback = callback;
    config.level.clearInterstitialDelay();
    this.visible = true;
    gsap.to(this.scale, {
      duration: .5,
      x: 1,
      y: 1,
      ease: "power4.out",
      onComplete: () => {
        config.coinsContainer.x = this.size.width / 2 - 100;
        config.coinsContainer.y = -this.size.height / 2 + 36;
        config.coinsContainer.scale.set(0);
        gsap.to(config.coinsContainer.scale, {
          duration: .2,
          x: 1,
          y: 1
        });
        this.addChild(config.coinsContainer);
        config.container.visible = false;
      }
    });
    this.scroll.visible = true;
    this.scroll.contentY = PACK_CONTAINER_POS * 2;
    gsap.to(this.scroll, {
      duration: .7,
      contentY: 0
    });
    config.levelProgressionMode && (config.homeMenu.skin.showAlert = false);
  }
  hide() {
    config.container.visible = true;
    config.coinsContainer.x = 450;
    config.coinsContainer.y = 147;
    config.header.addChild(config.coinsContainer);
    gsap.to(this.scale, {
      duration: .4,
      x: .1,
      y: .1,
      ease: "power2.in",
      onComplete: () => {
        this.visible = false;
        if (config.gameStarted) {
          config.level.launchInterstitialInterval();
        }
        this.callback && this.callback();
        this.scroll.visible = false;
      }
    });
  }
  setBtns() {
    let pos = 0;
    let decal = 10;
    if (this.items) {
      for (let i = 0; i < this.items.length; i++) {
        this.items[i].dispose();
      }
    }
    this.items = [];
    for (let i = 0; i < assets.packs.length; i++) {
      if (config.levelProgressionMode && i > 1 && i <= 10) {
        continue;
      }
      let item = new SkinItem(assets.packs[i].id, localeManager.words[assets.packs[i].title], assets.packs[i].textColor, assets.packs[i].price, assets.packs[i].bgColor, assets.packs[i].datas, assets.packs[i].level);
      item.click = this._skinAction;
      item.y = pos;
      pos += item.height + decal;
      this.packContainer.addChild(item);
      this.items.push(item);
    }
  }
  _skinAction(e) {
    config.level.skinBubbles(e.id);
    if (this._currentItem) {
      this._currentItem.selected = false;
      this._currentItem = null;
    }
    this._currentItem = e.currentTarget;
    this._currentItem.selected = true;
    config.sdk.getStoreModule().save("selectedSkin", {
      value: this._currentItem.themeId
    });
  }
  setUp() {
    this.selectedThemeId = config.selectedSkin;
    config.level.skinBubbles(this.selectedThemeId);
    if (config.purchasedTheme) {
      for (let i = 0; i < this.items.length; i++) {
        this.items[i].selected = false;
        for (let j = 0; j < config.purchasedTheme.length; j++) {
          if (config.purchasedTheme[j] == this.items[i].themeId || this.items[i].price == 0) {
            this.items[i].bought = true;
            if (this.selectedThemeId == this.items[i].themeId) {
              this.items[i].selected = true;
              this._currentItem = this.items[i];
            }
          }
        }
      }
    }
    config.homeMenu.checkForSkin();
  }
  checkForUnlock() {
    for (let i = 0; i < this.items.length; i++) {
      this.items[i].level <= config.playerLevel && this.items[i].unlock();
    }
  }
  getItemById(id) {
    return this.items[id];
  }
  checkForAlert() {
    for (let i = 0; i < this.items.length; i++) {
      if (!this.items[i].bought && parseFloat(this.items[i].price) <= config.coins) {
        return true;
      }
    }
    return false;
  }
  update() {
    this.scroll.update();
  }
}
